import React from 'react';

import { JuridictionAdminResponseDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import BaseModal from 'components/WrappedComponents/BaseModal';
import { useRefJuridiction } from 'hooks/referentiels/useRefJuridiction';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { typeJuridictionMapping } from 'utils/enumData';
import { LABEL_ID_CORRELATION } from 'utils/global';

interface ModalDetailsProps {
  juridiction: JuridictionAdminResponseDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  juridiction,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  const { data: juridictionParent } = useRefJuridiction(
    juridiction.idCorrelationJuridictionParent,
    'modalDetailsJuridictionParent',
  );

  return (
    <BaseModal
      width={BaseModalWidthUtils.xLargeWidth}
      isVisible={visible}
      closeModal={close}
      className="modalDetails"
    >
      <>
        <FieldDisplay
          label={LABEL_ID_CORRELATION}
          value={juridiction.idCorrelation}
        />
        <FieldDisplay label="Libellé" value={juridiction.libelle} />
        <FieldDisplay
          label="Type"
          value={typeJuridictionMapping[juridiction.type]}
        />
        <FieldDisplay label="Numéro" value={juridiction.numero} />
        <FieldDisplay label="Origine" value={juridiction.origineElement} />
        <FieldDisplay label="Code postal" value={juridiction.codePostal} />
        <FieldDisplay
          label="Juridiction parente"
          value={juridictionParent?.idCorrelation || null}
        />
        <FieldDisplay
          label="Libellé Juridiction parente"
          value={juridictionParent?.libelle || null}
        />
      </>
    </BaseModal>
  );
}

export default ModalDetails;
